namespace Cfnc {
    "use strict";

    interface ICollegeRecruiter {
    }

    interface ICollegeRecruiterScope extends ng.IScope {
        vm: CollegeRecruiter;
        actions: any;
        reasons: any;
    }

    class CollegeRecruiter implements ICollegeRecruiter {
        static $inject: Array<string> = ["common", "Restangular", "$scope"];
        static controllerId: string = "collegeRecruiter";
        private log;
        orgList: any;
        pageNumber: number;
        selectedLetter: string;
        searchString: string;
        selectedType: string;
        schoolCount: number;
        savedCollegeList: any;
        savedCollegeCount: number;
        loaded: boolean;
        savedSchoolLoaded: boolean;
        userProfile: any;
        demographics: any;
        parentGuardian: any;
        recruitedOnly: boolean;
        savedOrgList: any;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showHowl?) => void;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $scope: ICollegeRecruiterScope) {
            this.log = common.logger.getLogFn(CollegeRecruiter.controllerId);
            this.logSuccess = this.common.logger.getLogFn(CollegeRecruiter.controllerId, "success");
            this.logError = common.logger.getLogFn(CollegeRecruiter.controllerId, "error");
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.activate();
                }
            });

        }

        activate() {
            var promises = [];
            this.common.activateController(promises, CollegeRecruiter.controllerId)
                .then(() => {
                this.pageNumber = 1;
                this.searchString = "";
                this.loaded = false;
                this.recruitedOnly = false;
                this.getUserProfile();
                this.getSchoolList();
                this.getUserDemographics();
                this.getParentGuardianInfo();
            });
        }

        getUserProfile() {
            this.Restangular.one("users/profile").get().then((results) => {
                this.userProfile = results;
            }, (reason) => {
                this.logError("An error occurred while getting profile information", reason, true);
            });
        }

        getUserDemographics() {
            this.Restangular.one("users/demographics").get().then((result) => {
                this.demographics = result;
            }, (reason) => {
                this.logError("An error occurred while getting demographic information", reason, true);
            });
        }

        getParentGuardianInfo() {
            this.Restangular.one("users/parentguardianinfo").get().then((result) => {
                this.parentGuardian = result;
            }, (reason) => {
                this.logError("An error occurred while getting parent/guardian information", reason, true);
            });
        }

        getSchoolList() {
            var queryParams = { pageNumber: this.pageNumber, searchString: this.searchString, recruitedOnly: this.recruitedOnly };
            this.Restangular.one("Prospect/getFullOrgList").get(queryParams).then((results) => {
                this.loaded = true;
                this.orgList = results.organizations;
                this.schoolCount = results.organizationTotal;
            },(reason) => {
                this.logError("An error occurred while getting the list of colleges", reason, true);
                });
        }

        addRecruiter(applicationId: string) {
            var Name = { First: this.userProfile.firstName, Middle: this.userProfile.middleName, Last: this.userProfile.lastName, Suffix: this.userProfile.suffix };
            var mailAddress = { Street1: this.userProfile.mailAddress.street, Street2: "", City: this.userProfile.mailAddress.city, State: this.userProfile.mailAddress.state, Country: this.userProfile.mailAddress.country, Zip: this.userProfile.mailAddress.postalCode };
            var permAddress = { Street1: this.userProfile.permAddress.street, Street2: "", City: this.userProfile.permAddress.city, State: this.userProfile.permAddress.state, Country: this.userProfile.permAddress.country, Zip: this.userProfile.permAddress.postalCode };
            var additionalData = {
                daytimePhone: this.userProfile.daytimePhone,
                birthDate: this.userProfile.dateOfBirth,
                mailingPhone: this.userProfile.mailingPhone,
                permanentPhone: this.userProfile.phoneNumber,
                eveningPhone: this.userProfile.eveningPhone,
                graduationYear: this.userProfile.graduationYear,
                gender: this.userProfile.gender,
                socialSecurityNumber: this.userProfile.socialSecurityNumber,
                nickname: this.userProfile.nickname,
                enrollmentStatus: this.userProfile.enrollmentStatus,
                highSchool: this.userProfile.customer != null ? this.userProfile.customer.name : "",
                ceebCode: this.userProfile.customer != null ? this.userProfile.customer.ceeb_code : "",
                nationalities: this.demographics.nationalities,
                religiousAffiliation: this.demographics.religiousAffiliation,
                maritalStatus: this.demographics.maritalStatus,
                disabilities: this.demographics.disabilities,
                militaryServices: this.demographics.militaryServices,
                parentFirstName: this.parentGuardian.firstName,
                parentLastName: this.parentGuardian.lastName,
                parentAddressStreet1: this.parentGuardian.address != null ? this.parentGuardian.address.street : "",
                parentAddressStreet2: this.parentGuardian.address != null ? this.parentGuardian.address.street2 : "",
                parentAddressCity: this.parentGuardian.address != null ? this.parentGuardian.address.city : "",
                parentAddressState: this.parentGuardian.address != null ? this.parentGuardian.address.state : "",
                parentAddressCountry: this.parentGuardian.address != null ? this.parentGuardian.address.country : "",
                parentAddressZip: this.parentGuardian.address != null ? this.parentGuardian.address.postalCode : "",
                parentEmailAddress: this.parentGuardian.emailAddress,
                parentPhoneNumber: this.parentGuardian.phoneNumber,
                isFatherLiving: this.parentGuardian.isFatherLiving,
                isMotherLiving: this.parentGuardian.isMotherLiving,
                isParentVeteran: this.parentGuardian.isParentVeteran,
                parentDisabledInMilitary: this.parentGuardian.parentDisabledInMilitary,
                parentKilledInMilitary: this.parentGuardian.parentKilledInMilitary,
                parentsGraduatedCollege: this.parentGuardian.parentsGraduatedCollege
            };
            var prospect = { id: "", applicationDefinitionId: applicationId, userId: "", source: "College Recruiter", name: Name, mailingAddress: mailAddress, physicalAddress: permAddress, email: this.userProfile.email, dateCreated: new Date(), additionalData: additionalData }; 
            this.Restangular.all("Prospect/addRecruiterAdditionalData").post(prospect).then((results) => {
                this.logSuccess("Recruiter information has been submitted.", null, true);
            },(reason) => {
                this.logError("An error occurred while submitting recruiter information", reason, true);
                });
        }

        getListofSchools = (baseString: string) => {
            var query = { startsWith: baseString };
            return this.Restangular.all("Prospect/getListofRecruiterSchools").getList(query)
                .then((result) => {
                    return result;
                });
        };
    }

    angular.module("app").controller(CollegeRecruiter.controllerId, CollegeRecruiter);
} 